"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _ = require("..");

var _useHover = _interopRequireDefault(require("../useHover"));

var _ButtonRaw = _interopRequireDefault(require("../ButtonRaw"));

var _Box = _interopRequireDefault(require("../Box"));

var __jsx = _react["default"].createElement;
var commonResetStyles = {
  position: "relative",
  display: "inline-block",
  verticalAlign: "top"
};
var buttonResetStyles = {
  border: 0,
  margin: 0,
  padding: 0,
  width: "auto",
  overflow: "visible",
  background: "transparent",
  color: "inherit",
  font: "inherit",
  lineHeight: "normal",
  fontSmooth: "inherit",
  appearance: "none",
  ":not(:disabled)": {
    cursor: "pointer"
  },
  textAlign: "left"
};
var linkResetStyles = {
  color: "inherit",
  textDecoration: "none",
  boxSizing: "border-box"
};

var Button = _react["default"].forwardRef(function (props, _ref) {
  // look
  var disabled = props.disabled,
      children = props.children,
      label = props.label,
      selected = props.selected,
      buttonRef = props.buttonRef,
      isLoading = props.isLoading,
      href = props.href,
      _props$forceLink = props.forceLink,
      forceLink = _props$forceLink === void 0 ? false : _props$forceLink,
      sx = props.sx,
      _props$__minimalLinkS = props.__minimalLinkStyling,
      __minimalLinkStyling = _props$__minimalLinkS === void 0 ? false : _props$__minimalLinkS,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["disabled", "children", "label", "selected", "buttonRef", "isLoading", "href", "forceLink", "sx", "__minimalLinkStyling"]);

  _ref = buttonRef || _ref; // buttonRef is legacy, backward compatibility

  var hoverRef = (0, _react.useRef)(null);
  var isHovered = (0, _useHover["default"])(hoverRef);
  var state = {
    selected: selected,
    disabled: disabled,
    isHovered: isHovered,
    isLoading: isLoading,
    loading: isLoading,
    hovered: isHovered
  };
  sx = typeof sx === "function" ? sx(state) : sx;

  var _splitSx = (0, _.splitSx)(sx),
      _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
      css = _splitSx2[0],
      customSx = _splitSx2[1];

  var mainProps = {
    ref: function ref(element) {
      hoverRef.current = element; // We must remember that ref that is passed here can be function or object! However, for internal use (useHover) we need object.

      if (typeof _ref === "function") {
        _ref(element);
      } else if (buttonRef) {
        _ref.current = element;
      }
    },
    disabled: disabled
  };

  if (href || forceLink) {
    mainProps.sx = (0, _objectSpread2["default"])({}, !__minimalLinkStyling && commonResetStyles, linkResetStyles, sx);
    mainProps.as = "a";
    mainProps.href = href;
  } else {
    mainProps.sx = [(0, _objectSpread2["default"])({}, commonResetStyles, buttonResetStyles), sx];
    mainProps.as = "button";
  }

  return __jsx(_Box["default"], (0, _extends2["default"])({}, restProps, mainProps), typeof children === "function" ? children(state) : children);
});

var _default = Button;
exports["default"] = _default;